import React, { Component } from "react";
/*import StatusIcon from '../component/StatusIcon';*/

export default class StatusSection extends Component {
  /*constructor(props) {
    super(props);
  }*/

  componentDidMount() {}

  render() {
    return (
      <div
        style={{
          width: "100%",
          height: "130",
          borderRadius: 5,
          backgroundColor: "#057748",
          margin: "auto",
          paddingTop: 40,
          paddingBottom: 40,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <p style={{ color: "white", marginLeft: 20 }}>Status</p>
        <div
          style={{
            display: "flex",
            width: "100%",
            height: "auto",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          {this.props.children.map((c, i) => {
            return (
              <div
                key={i}
                onClick={() => {
                  // console.log("onClick triggered")
                }}
              >
                {c}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/component/StatusSection.js